import { render } from "./PopularScience.vue?vue&type=template&id=af51dcb2&scoped=true"
import script from "./PopularScience.vue?vue&type=script&lang=js"
export * from "./PopularScience.vue?vue&type=script&lang=js"

import "./PopularScience.vue?vue&type=style&index=0&id=af51dcb2&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af51dcb2"]])

export default __exports__